export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-mail-2c2d0922b0705b16218f4f64534be65a.svg";